const secondaryObjectMappingWithDiffProperty = {
  'QPathMaps': 'URL parameter',
  'EventCallBacks': 'tracking pixel'
};

const actionStatementMapping = Object.freeze({
  'Campaign': {
    'BatchUpdateCampaignDefaultPayouts': {
      statement: '<strong>[{userName}]</strong> updated default payout settings of campaign <strong>[{objectName}]</strong>'
    },
    'BatchUpdatePublisherPayouts': {
      statement: '<strong>[{userName}]</strong> updated publisher payout settings of campaign <strong>[{objectName}]</strong>'
    },

    'AddIvrTreeToCampaign': {
      statement: '<strong>[{userName}]</strong> updated campaign <strong>[{objectName}]</strong> to use IVR'
    },
    'RemoveIvrTreeFromCampaign': {
      statement: '<strong>[{userName}]</strong> updated campaign <strong>[{objectName}]</strong> to use priority routing'
    },

    'AddCallRoute': {
      statement: '<strong>[{userName}]</strong> added a new route to the routing plan of campaign <strong>[{objectName}]</strong>'
    },
    'DeleteCallRoute': {
      statement: '<strong>[{userName}]</strong> removed a route from the routing plan of campaign <strong>[{objectName}]</strong>'
    },
    'ChangeRouteType': {
      statement: '<strong>[{userName}]</strong> changed call routing criteria of campaign <strong>[{objectName}]</strong>'
    },

    'AddAffiliateNumber': {
      statement: '<strong>[{userName}]</strong> added a number(associated with a publisher) to campaign <strong>[{objectName}]</strong>'
    },
    'RemoveAffiliateFromNumber': {
      statement: '<strong>[{userName}]</strong> removed a number(associated with a publisher) from campaign <strong>[{objectName}]</strong>'
    },
    'AddPublisher': {
      statement: '<strong>[{userName}]</strong> added a publisher to campaign <strong>[{objectName}]</strong>'
    },
    'DeletePublisher': {
      statement: '<strong>[{userName}]</strong> removed a publisher from campaign <strong>[{objectName}]</strong>'
    },

    'CreateTag': {
      statement: '<strong>[{userName}]</strong> created a call tracking tag for campaign <strong>[{objectName}]</strong>'
    },
    'UpdateTag': {
      statement: '<strong>[{userName}]</strong> updated a call tracking tag in campaign <strong>[{objectName}]</strong>'
    },
    'DeleteTag': {
      statement: '<strong>[{userName}]</strong> deleted a call tracking tag from campaign <strong>[{objectName}]</strong>'
    },

    'SetCampaignOfferDraft': {
      statement: '<strong>[{userName}]</strong> updated offer draft for campaign <strong>[{objectName}]</strong>'
    },
    'DeleteCampaignOfferDraft': {
      statement: '<strong>[{userName}]</strong> deleted offer draft for campaign <strong>[{objectName}]</strong>'
    },
    'PublishCampaignOfferDraft': {
      statement: '<strong>[{userName}]</strong> published drafted offer for campaign <strong>[{objectName}]</strong>'
    },
    'PauseCampaignOffer': {
      statement: '<strong>[{userName}]</strong> paused offer for campaign <strong>[{objectName}]</strong>'
    },
    'ResumeCampaignOffer': {
      statement: '<strong>[{userName}]</strong> resumed offer for campaign <strong>[{objectName}]</strong>'
    },
    'ArchiveOffer': {
      statement: '<strong>[{userName}]</strong> stopped offer for campaign <strong>[{objectName}]</strong>'
    },
    'InvitePublisherToOffer': {
      statement: '<strong>[{userName}]</strong> invited publisher to join offer for campaign <strong>[{objectName}]</strong>'
    },

    'LinkItemToCampaign': {
      linkedWithAnotherItem: true,
      secondaryObjectMappingWithDiffProperty,
      statement: '<strong>[{userName}]</strong> added [{secondaryObjectName}] to campaign <strong>[{objectName}]</strong>'
    },

    'UnlinkItemFromCampaign': {
      linkedWithAnotherItem: true,
      secondaryObjectMappingWithDiffProperty,
      statement: '<strong>[{userName}]</strong> removed [{secondaryObjectName}] from campaign <strong>[{objectName}]</strong>'
    }
  }
});


export default actionStatementMapping;